module.exports = __webpack_public_path__ + "static/media/iciciAbout.e225ad82.png";